import type { LevelConfig } from '../types'
import { inglenookSidings } from './inglenook-sidings'
import { levelSelection } from './level-selection'
import { level1 } from './level1'
import { level2 } from './level2'
import { level3 } from './level3'
import { level4 } from './level4'
import { level5 } from './level5'
import { level6 } from './level6'
import { titleScreen } from './title'
import { tutorial1, tutorial2, tutorial3, tutorial4, tutorial5 } from './tutorial'

export const LEVELS_MAP: Record<string, LevelConfig> = {
  titleScreen, //0
  levelSelection, //1
  tutorial1, //2
  tutorial2, //3
  tutorial3, //4
  level1, //5
  tutorial4, //6
  level2, //7
  tutorial5, //8
  level3, //9
  level4, //10
  level5, //11
  level6, //12
  inglenookSidings, //13+
}

export const LEVELS = Object.values(LEVELS_MAP)
